import { f7 } from "framework7-react";
import { openBackLayer } from "../hooks/use-back-close";
import { escapeHtml } from "./escape-html";

// Escapes everything itself (F7 renders HTML here): callers pass plain text.
export const confirmDialog = ({
  title,
  text,
  confirmText,
  destructive = false,
  cssClass,
  onConfirm,
  onClosed,
}) => {
  const dialog = f7.dialog.create({
    title: escapeHtml(title),
    text: escapeHtml(text),
    cssClass,
    buttons: [
      { text: "Abbrechen" },
      {
        text: escapeHtml(confirmText),
        strong: true,
        ...(destructive && { color: "red" }),
        onClick: onConfirm,
      },
    ],
    on: {
      close: () => releaseBack(),
      ...(onClosed && { closed: onClosed }),
    },
  });
  const releaseBack = openBackLayer(() => dialog.close());
  return dialog.open();
};
